import { useEffect, useRef } from "react";
// Import league logos
import ligue1 from "../assets/cover/league/Ligue_1.png";
import can from "../assets/cover/league/caf.png";
import motogp from "../assets/cover/league/Moto_Gp.png";
import uefaNations from "../assets/cover/league/UEFA_Nations.png";
import rsl from "../assets/cover/league/rsl.png";
import bundesliga from "../assets/cover/league/Bundesliga.png";
import mls from "../assets/cover/league/MLS.png";
import ligaportugal from "../assets/cover/league/Primeira_Liga.png";
import seriaA from "../assets/cover/league/Serie_A.png";
import premierLeague from "../assets/cover/league/Premier_League.png";
import f1 from "../assets/cover/league/F1.png";
import fifaWorldCup from "../assets/cover/league/2026_FIFA_World_Cup.png";
import europaLeague from "../assets/cover/league/UEFA_Europa_League.png";
import champions from "../assets/cover/league/Logo_Champions_League.png";
import laliga from "../assets/cover/league/LaLiga.png";
import copa from "../assets/cover/league/Copa_Del_Rey.png";
import dazn from "../assets/cover/league/DAZN.png";
import supercopa from "../assets/cover/league/Supercopa.png";

// Import sports images
import s1 from "../assets/cover/sports/1.webp";
import s2 from "../assets/cover/sports/2.webp";
import s3 from "../assets/cover/sports/3.webp";
import s41 from "../assets/cover/sports/41.webp";
import s51 from "../assets/cover/sports/51.webp";
import carlos from "../assets/cover/sports/Carlos Alca.webp";
import clasico from "../assets/cover/sports/clasico.webp";
import eredevise from "../assets/cover/sports/eredevise.webp";
import euro2024 from "../assets/cover/sports/euro 2024 champs.webp";
import f1poster from "../assets/cover/sports/f1poster.webp";
import laligaSport from "../assets/cover/sports/laliga.webp";
import ligaEndesa from "../assets/cover/sports/liga endesa.webp";
import maroc2025 from "../assets/cover/sports/maroc 2025.webp";
import motogpSport from "../assets/cover/sports/motogp.webp";
import nascar from "../assets/cover/sports/nascarsports.webp";
import nba from "../assets/cover/sports/nba.webp";
import olympic from "../assets/cover/sports/olympic 2024 champs.webp";
import roger from "../assets/cover/sports/roger nadal.webp";
import ufc from "../assets/cover/sports/ufc.webp";

export default function Sports() {
  const carouselRef = useRef(null);
  const scrollInterval = useRef(null);

  // Block any manual scroll/drag while keeping programmatic autoplay
  const blockUserScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // Import all sports images
  const sportsImages = [
    f1poster,
    maroc2025,
    laligaSport,
    eredevise,
    nascar,
    nba,
    motogpSport,
    ufc,
    roger,
    clasico,
    euro2024,
    olympic,
    ligaEndesa,
    carlos,
    s1,
    s2,
    s3,
    s41,
    s51,
  ];

  // Import all league logos
  const leagueLogos = [
    { name: "La Liga", src: laliga },
    { name: "Copa Del Rey", src: copa },
    { name: "Supercopa", src: supercopa },
    { name: "Champions League", src: champions },
    { name: "FIFA World Cup", src: fifaWorldCup },
    { name: "UEFA Nations League", src: uefaNations },
    { name: "Europa League", src: europaLeague },
    { name: "Premier League", src: premierLeague },
    { name: "DAZN", src: dazn },
    { name: "ligue1", src: ligue1 },
    { name: "Serie A", src: seriaA },
    { name: "RSL", src: rsl },
    { name: "Bundesliga", src: bundesliga },
    { name: "MLS", src: mls },
    { name: "Liga Portugal", src: ligaportugal },
    { name: "Formula 1", src: f1 },
    { name: "MotoGP", src: motogp },
    { name: "can", src: can },
  ];

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    // Create infinite scroll effect
    const startInfiniteScroll = () => {
      scrollInterval.current = setInterval(() => {
        const singleSetWidth = carousel.scrollWidth / 3; // Since we have 3 copies
        const currentScroll = carousel.scrollLeft;
        
        // Reset to beginning when we've scrolled through one complete set
        if (currentScroll >= singleSetWidth) {
          carousel.scrollLeft = 0;
        } else {
          carousel.scrollLeft += 1;
        }
      }, 20); // Smooth 50fps animation
    };

    // Wait for images to load and carousel to be properly initialized
    const initializeCarousel = () => {
      // Check if all images are loaded
      const images = carousel.querySelectorAll('img');
      const loadedImages = Array.from(images).filter(img => img.complete);
      
      // If all images are loaded or after a reasonable timeout, start the carousel
      if (loadedImages.length === images.length || loadedImages.length > 0) {
        startInfiniteScroll();
      } else {
        // Wait for images to load with a maximum timeout
        setTimeout(() => {
          startInfiniteScroll();
        }, 500);
      }
    };

    // Start initialization after a short delay to ensure DOM is ready
    setTimeout(initializeCarousel, 100);

    return () => {
      if (scrollInterval.current) {
        clearInterval(scrollInterval.current);
      }
    };
  }, []);

  return (
    <>
      <section className="py-16 bg-slate-50">
        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
          <div className="text-center mb-12">
            <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-black bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] mb-4 max-w-3xl leading-snug text-center">
              Deportes en Vivo y Contenido Deportivo Premium
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Disfruta de todos los deportes y ligas más importantes del
              mundo en una sola suscripción
            </p>
          </div>

          {/* Infinite Carousel */}
          <div className="relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full bg-transparent z-10"></div>
            <div
              ref={carouselRef}
              className="flex space-x-4 overflow-hidden carousel-container"
              style={{
                scrollBehavior: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                touchAction: "none",
                overscrollBehaviorX: "contain",
              }}
              onWheel={blockUserScroll}
              onTouchStart={blockUserScroll}
              onTouchMove={blockUserScroll}
              onPointerDown={blockUserScroll}
              onMouseDown={blockUserScroll}
            >
              {[...sportsImages, ...sportsImages, ...sportsImages].map(
                (image, index) => {
                  return (
                    <div
                      key={`${index}-${Math.random()}`}
                      className="flex-shrink-0 group relative"
                    >
                      <div className="relative w-48 h-80 md:w-52 md:h-[22rem] rounded-2xl overflow-hidden transition-all duration-500 shadow-md mb-2">
                        <img
                          src={image}
                          alt={`Sport ${index + 1}`}
                          className="w-full h-full object-cover transition-transform duration-500 carousel-image"
                          draggable={false}
                          onDragStart={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  );
                }
              )}
            </div>
            {/* Edge fade overlays */}
            <div className="carousel-edge-left"></div>
            <div className="carousel-edge-right"></div>
          </div>

          {/* League Logos Grid */}
          <div className="mt-5">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {leagueLogos.map((logo, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 border border-gray-100"
                >
                  <div className="flex items-center justify-center h-8">
                    <img
                      src={logo.src}
                      alt={logo.name}
                      className="max-h-14 max-w-full object-contain filter group-hover:brightness-110 transition-all duration-300"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
